import React from 'react'
import { useTranslation } from 'react-i18next'
import { TextAction } from '@node-space/storybook-components/dist/TextAction'
import { Text } from '@node-space/ui-components'
import { ExternalLinks } from 'constants/ExternalLinks'

export interface CustomLabelProps {
  code: string
}

export const CustomLabel = ({ code }: CustomLabelProps) => {
  const { t } = useTranslation()
  const translationKey = `businessCompliance.questionLabel.${code}`

  switch (code) {
    case 'qAnyExposureToBvnkProhibitedJurisdictions':
      return (
        <Text tag="span" variant="body-label">
          {t(`${translationKey}.preLink`)}
          <TextAction
            text={t(`${translationKey}.link`)}
            linkTo={ExternalLinks.financialCrimeRiskAppetitePolicy}
          />
          ?
        </Text>
      )
    default:
      return
  }
}
